import apiClient from '@/services/axios'

export async function get(venueDetailsId) {

  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + `/admin/bookings/bookings-on-deactivated-tables/${venueDetailsId.id}`);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get bookings.');
}
